import React from 'react';
import Header from '../../../components/landing/Header';
import HeroSection from '../../../components/landing/HeroSection';
import USPSection from '../../../components/landing/USPSection';
import DestinationsSection from '../../../components/landing/DestinationsSection';
import FeaturesSection from '../../../components/landing/FeaturesSection';
import HowItWorksSection from '../../../components/landing/HowItWorksSection';
import StatsSection from '../../../components/landing/StatsSection';
import TestimonialsSection from '../../../components/landing/TestimonialsSection';
import AvailableBedsSection from '../../../components/landing/AvailableBedsSection';
import CTASection from '../../../components/landing/CTASection';
import Footer from '../../../components/landing/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="bg-background flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <HeroSection />
        <USPSection />
        <StatsSection />
        <DestinationsSection />
        <FeaturesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AvailableBedsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;